"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidHEXColor = isValidHEXColor;
exports.shadeRGBColor = shadeRGBColor;
exports.hexToRGB = hexToRGB;

//
// Copyright (c) 2020 Nutanix Inc. All rights reserved.
//

/**
 * Check if value is valid HEX color
 *
 * @param {string} value - color to validate
 * @returns {boolean} - {true} if valid HEX color
 */
function isValidHEXColor(value) {
  return /^#([0-9A-F]{3}){1,2}$/i.test(value);
}
/**
 * Shades provided RGB color
 *
 * @param {string} color - RGB color
 * @param {number} percent - percent to shade color
 * @returns {string} - new RGB color
 */


function shadeRGBColor(color, percent) {
  var f = color.split(',');
  var t = percent < 0 ? 0 : 255;
  var p = percent < 0 ? percent * -1 : percent;
  var r = parseInt(f[0].slice(4), 10);
  var g = parseInt(f[1], 10);
  var b = parseInt(f[2], 10);
  var rValue = Math.round((t - r) * p) + r;
  var gValue = Math.round((t - g) * p) + g;
  var bValue = Math.round((t - b) * p) + b;
  return "rgb(".concat(rValue, ", ").concat(gValue, ", ").concat(bValue, ")");
}
/**
 * Converts hex color to RGB/A
 *
 * @param {string} hex - hex color
 * @param {number} alpha - Opacity level on hex
 * @returns {string} - rgb/a color
 */


function hexToRGB(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
  }

  return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}